// next
import { NextApiRequestCookies } from 'next/dist/server/api-utils';
// config
import { cookiesKey, defaultSettings } from '../config';
import { SettingsValueProps } from '../components/settings/type';
import Cookies from 'js-cookie';

// ----------------------------------------------------------------------

export const getSettings = (cookies: NextApiRequestCookies) => {
  const themeMode = getData(cookies[cookiesKey.themeMode]) || defaultSettings.themeMode;

  const themeDirection =
    getData(cookies[cookiesKey.themeDirection]) || defaultSettings.themeDirection;

  const themeColorPresets =
    getData(cookies[cookiesKey.themeColorPresets]) || defaultSettings.themeColorPresets;

  const themeLayout = getData(cookies[cookiesKey.themeLayout]) || defaultSettings.themeLayout;

  const themeContrast = getData(cookies[cookiesKey.themeContrast]) || defaultSettings.themeContrast;

  const themeStretch = getData(cookies[cookiesKey.themeStretch]) || defaultSettings.themeStretch;

  const welcomeToT2C = getData(cookies[cookiesKey.welcomeToT2C]) || defaultSettings.welcomeToT2C;

  return {
    themeMode,
    themeLayout,
    themeStretch,
    themeContrast,
    themeDirection,
    themeColorPresets,
    welcomeToT2C,
  };
};

export const getSettingsDefault = () => {
  const defaultSetting: SettingsValueProps = {
    themeMode: 'dark',
    themeColorPresets: 'default',
    themeDirection: 'ltr',
    themeLayout: 'horizontal',
    themeStretch: false,
    themeContrast: 'default',
    welcomeToT2C: 'welcomeToT2CV1',
  };
  return defaultSetting;
};

export const getSettingsFromCookies: () => SettingsValueProps = () => {
  const themeMode = Cookies.get(cookiesKey.themeMode) || defaultSettings?.themeMode;
  const themeDirection = Cookies.get(cookiesKey.themeDirection) || defaultSettings?.themeDirection;
  const themeColorPresets =
    Cookies.get(cookiesKey.themeColorPresets) || defaultSettings?.themeColorPresets;
  const themeLayout = Cookies.get(cookiesKey.themeLayout) || defaultSettings?.themeLayout;
  const themeContrast = Cookies.get(cookiesKey.themeContrast) || defaultSettings?.themeContrast;
  const themeStretch = Cookies.get(cookiesKey.themeStretch) || 'false';
  const welcomeToT2C = Cookies.get(cookiesKey.welcomeToT2C) || defaultSettings?.welcomeToT2C;
  const defaultSet = {
    themeMode,
    themeDirection,
    themeColorPresets,
    themeLayout,
    themeContrast,
    themeStretch,
    welcomeToT2C,
  };
  return getSettings(defaultSet);
};

// ----------------------------------------------------------------------

export const getData = (value: string | undefined) => {
  if (value === 'true' || value === 'false') {
    return JSON.parse(value);
  }
  if (value === 'undefined' || !value) {
    return '';
  }
  return value;
};
